import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToolListService } from './tool-list.service';

@Component({
  selector: 'app-tool-list',
  templateUrl: 'tool-list.component.html',
  styleUrls: ['tool-list.component.scss'],
})
export class ToolListComponent implements OnInit, OnDestroy {
  constructor(private _toolListService: ToolListService) {}

  ngOnInit(): void {
    this._toolListService.init();
  }
  ngOnDestroy(): void {
    this._toolListService.destroy();
  }
}
